import Component from 'navigation/component/Component';
import { extractInfoFromXhr } from 'navigation/page-manager/CustomPageManager';
import store from 'store';
import NewsletterForm from 'components/newsletter-form/NewsletterForm';
import DrawerPanel from 'components/drawer-panel/DrawerPanel';
class Footer extends Component {
    pageManager;
    loading;
    constructor(el, options) {
        super(el, options);
        this.pageManager = options.parent.pageManager;
    }
    initialized() {
        this.refs.selectLinks.push(this.refs.webstoreSwitcher);
        super.initialized();
        this.modules.newsletterForm.submitCallback = this.onFormSubmit;
    }
    bindEvents(add = true) {
        const m = add ? 'addEventListener' : 'removeEventListener';
        if (this.refs.footerAccordion) {
            this.refs.footerAccordion.forEach(a => {
                a[m]('click', this.onAccordionClick);
            });
        }
        if (this.refs.webstoreSwitcher)
            this.refs.webstoreSwitcher[m]('click', this.onWebstoreSwitcherClick);
        this.refs.selectLinks?.forEach((link) => {
            link[m]('mouseenter', (e) => this.onLinkMouseEnter(e));
            link[m]('mouseleave', (e) => this.onLinkMouseLeave(e));
        });
    }
    bindModules() {
        super.bindModules();
    }
    onWebstoreSwitcherClick(event) {
        store.drawer.set('webstore-switcher');
    }
    onLinkMouseEnter = (e) => {
        this.refs.selectLinks.forEach((link) => {
            link.className = 'inactive';
            if (link === e.target)
                link.className = 'active';
        });
    };
    onLinkMouseLeave = (e) => {
        this.refs.selectLinks.forEach((link) => {
            link.classList.remove('active');
            link.classList.remove('inactive');
        });
    };
    onFormSubmit = (formData, urlParameters) => {
        const form = this.modules.newsletterForm;
        const xhr = new XMLHttpRequest();
        this.loading = true;
        xhr.withCredentials = true;
        xhr.open(form.method, form.action, true);
        xhr.responseType = 'document';
        xhr.onload = this.onXhrComplete;
        xhr.send(formData);
        return false;
    };
    onXhrComplete = (event) => {
        const form = this.modules.newsletterForm;
        form.submitted = false;
        this.loading = false;
        const xhr = event.currentTarget;
        extractInfoFromXhr(xhr);
        xhr.onload = null;
        this.modules.newsletterForm.clear();
    };
    onAccordionClick = ({ currentTarget }) => {
        currentTarget.classList.toggle('opened');
    };
    getModulesMap() {
        return {
            newsletterForm: ['.footer__form', NewsletterForm],
            footerAccordion: ['.footer__accordion', DrawerPanel]
        };
    }
}
export default Footer;
